import { render, staticRenderFns } from "./DashboardReceivedRecordings.vue?vue&type=template&id=b53a5344&scoped=true"
import script from "./DashboardReceivedRecordings.vue?vue&type=script&lang=js"
export * from "./DashboardReceivedRecordings.vue?vue&type=script&lang=js"
import style0 from "./DashboardReceivedRecordings.vue?vue&type=style&index=0&id=b53a5344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53a5344",
  null
  
)

export default component.exports